import { render, staticRenderFns } from "./RenewalsPanel.vue?vue&type=template&id=5cb8b60d&scoped=true&"
import script from "./RenewalsPanel.vue?vue&type=script&lang=js&"
export * from "./RenewalsPanel.vue?vue&type=script&lang=js&"
import style0 from "./RenewalsPanel.vue?vue&type=style&index=0&id=5cb8b60d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8b60d",
  null
  
)

export default component.exports